import React from "react";
import RestImageCarousel from "./components/rest-image-carousel/RestImageCarousel";
import RestList from "./components/rest-list/RestList";
import MainPageCarousel from "./components/rest-image-carousel/MainPageCarousel";
// import RestImageCarousel from "./components/rest-image-carousel/RestImageCarousel.jsx";
// import RestList from "./components/rest-list/RestList.jsx";

const MainPage = ({ restID }) => {
  return (
    <div className="main-page">
      {/* <RestImageCarousel key={restID} restID={restID} /> */}
      <MainPageCarousel key={restID} restID={restID} />
      <RestList restID={restID} />
    </div>
  );
};

export default MainPage;
